import React from 'react';
import Title from './Title';
import { PageContentWrapper } from '../../shared/styled/PageContentStyle';
import { KpiCategoryTable } from './CustomTable';
import { KpiCategoryTableColumns } from '../../configs/kpi';
import ListView from '../../shared/components/ListView';
import TabNavigation from './TabNavigation';

const KpiList = () => {
    return (
        <PageContentWrapper>
            <Title />
            <TabNavigation />
        </PageContentWrapper>
    );
};

export default KpiList;
